import { ShipmentProductSchema } from "@redotech/redo-model/inventory/inventory";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const MerchantSchema = z.object({
  id: zExt.objectId(),
  name: z.string().optional().nullable(),
});

export type Merchant = z.infer<typeof MerchantSchema>;

export const GetShippingLabelProductsOutputSchema = z.object({
  merchant: z.object({
    id: zExt.objectId(),
    name: z.string().optional().nullable(),
  }),
  products: z.array(ShipmentProductSchema),
});

export const getShippingLabelProducts = unaryRpc({
  name: "getShippingLabelProducts" as const,
  input: z.object({ code: z.string() }),
  output: GetShippingLabelProductsOutputSchema,
});
